// Nederlandse teksten voor Te beoordelen. Dezelfde sleutels als queue.en.ts.
//
// "In de wachtrij" is het sterkste woord hier: goedkeuren zet een opdracht klaar,
// alleen de opdracht zelf meldt of de boekhouding het aannam.

import type { Message, Vars } from './en.ts';
import type { queueEn } from './queue.en.ts';

export const queueNl: Readonly<Record<keyof typeof queueEn, Message>> = {
  'queue.intro': 'Alles wat op jouw akkoord wacht.',
  'queue.tab.all': 'Alles',
  'queue.tab.document': 'Documenten',
  'queue.tab.bank_match': 'Bank',
  'queue.tab.request': 'Klantverzoeken',
  'queue.tab.proposal': 'Voorstellen',
  'queue.tab.operation': 'Boekingen onderweg',
  'queue.tabs': 'Soort werk',
  'queue.filter': 'Filter op status',
  'queue.filter.all': 'Elke status',
  'queue.status.ready': 'Klaar voor goedkeuring',
  'queue.status.check': 'Controleren',
  'queue.reading': 'Bezig met lezen…',
  'queue.empty': 'Er wacht niets op je akkoord.',
  'queue.emptyFiltered': 'Niets met deze status.',
  'queue.error.absent': 'Dat kantoor is niet beschikbaar in deze sessie.',
  'queue.error.read': 'De lijst kon niet worden gelezen.',
  'queue.select': (v: Vars) => `${v['name']} selecteren om te beoordelen`,
  'queue.review': (v: Vars) => `${v['count']} geselecteerd beoordelen`,
  'queue.reviewReading': 'Bezig met lezen…',
  'queue.loadMore': 'Meer laden',
  'queue.loadingMore': 'Laden…',
  'queue.cols.name': 'Naam',
  'queue.cols.date': 'Datum',
  'queue.cols.status': 'Status',
  'queue.cols.amount': 'Bedrag',

  // --- de beoordeling ---------------------------------------------------------
  'queue.batch.titleDone': 'Wat er is verstuurd',
  'queue.batch.title': 'Controleren vóór goedkeuren',
  'queue.batch.doneLine': (v: Vars) => `${v['queued']} in de wachtrij, ${v['refused']} geweigerd, ${v['other']} niet verstuurd.`,
  'queue.batch.line': (v: Vars) => `${v['selected']} geselecteerd · ${v['ready']} kan worden goedgekeurd`,
  'queue.batch.document': 'Document',
  'queue.batch.invoice': 'Factuur',
  'queue.batch.total': 'Totaal',
  'queue.batch.revision': 'Versie',
  'queue.batch.outcome': 'Uitkomst',
  'queue.batch.open': 'Openen',
  'queue.batch.footDone':
    'De worker verstuurt elke opdracht in de wachtrij. Alleen de opdracht zelf meldt of de boekhouding het aannam — open een document om er een te volgen.',
  'queue.batch.foot':
    'Goedkeuren verstuurt één verzoek per item, elk met zijn eigen verwachte versie. Voor de regels hierboven die niet kunnen worden goedgekeurd, wordt niets verstuurd.',
  'queue.batch.approving': 'Bezig met goedkeuren…',
  'queue.batch.approve': (v: Vars) => `${v['count']} goedkeuren`,
  'queue.outcome.queued': 'In de wachtrij',
  'queue.outcome.notSent': 'Niet verstuurd',
  'queue.outcome.blocked': 'Kan niet worden goedgekeurd',
  'queue.outcome.waiting': 'Wachten…',
  'queue.outcome.ready': 'Klaar voor goedkeuring',
  'queue.blocked.unreadable': 'Kon niet worden gelezen, dus hiervoor wordt niets verstuurd.',
  'queue.blocked.absent': 'Niet meer beschikbaar in jouw sessie.',
  'queue.blocked.role': (v: Vars) => `Jouw rol (${v['role']}) mag geen boeking goedkeuren.`,
  'queue.blocked.noProposal': 'Voor dit document is nog geen voorstel voorbereid.',
  'queue.blocked.blockers': (v: Vars) => `Gestopt voordat de voorbereiding klaar was: ${v['codes']}.`,
  'queue.blocked.status': (v: Vars) => `Het voorstel heeft de status ${v['status']}, dus er is niets om goed te keuren.`,
  'queue.blocked.noRevision': 'Dit voorstel heeft geen actuele versie om goed te keuren.',
  'queue.refusal.generic': 'Het verzoek kon niet worden afgerond.',
  'queue.refusal.stale': 'Dit is veranderd nadat het werd gelezen, dus er is niets voor verstuurd. Beoordeel het opnieuw.',
  'queue.refusal.forbidden': 'Jouw rol mag dit niet.',
  'queue.refusal.fields': (v: Vars) => `Geweigerd: ${v['fields']}.`,
  'queue.refusal.validation': 'controle mislukt',
};
